import React from 'react'
import Layout from './Layout'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../features/authSlice";
import RiwayatKepangkatanList from '../components/RiwayatKepangkatanList';
import { useEffect } from 'react';


const RiwayatKepangkatan = () => {
    const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, navigate]);
  return (
    <Layout>
      <RiwayatKepangkatanList/>
    </Layout>
  )
}

export default RiwayatKepangkatan